import axios from 'axios';
import type { Topic } from '@/models/topic';
import { ApprovalState } from '@/components/prine/enums/ApprovalState';

class TopicWebservice {
    public load() {
        return axios.get<Topic[]>('/topics');
    }

    public loadTopicsByTradeAndPhaseWithLessons(tradeId: number, phaseId: number, approvalState: ApprovalState) {
        if (approvalState === ApprovalState.ALL) {
            return axios.get<Topic[]>('topics/byTradeWithLessons', {
                params: {
                    tradeId,
                    phaseId,
                },
            });
        } else {
            return axios.get<Topic[]>('topics/byTradeWithLessons', {
                params: {
                    tradeId,
                    phaseId,
                    approved: approvalState === ApprovalState.APPROVED ? 1 : 0,
                },
            });
        }
    }

    public store(topic: Topic) {
        return axios.post('/topics/store', {
            title: topic.title,
        });
    }

    public update(topic: Topic) {
        return axios.post('/topics/update', {
            id: topic.id,
            title: topic.title,
        });
    }

    public getById(topicId: string) {
        return axios.get<Topic>('/topics/getById', {
            params: {
                topicId,
            },
        });
    }

    public remove(topic: Topic) {
        return axios.post('/topics/remove', {
            id: topic.id,
        });
    }
}

export const topicWebservice = new TopicWebservice();
